import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import { apiUrl } from 'Api/Api';

import UserContext from 'store/UserContext';

function AddEditModal(props) {
  console.log('MY PROPS', props);
  const team = props.teamInfo;
  const user_context = useContext(UserContext);
  const [isSwitchOn, setIsSwitchOn] = useState(true);
  const [validated, setValidated] = useState(false);
  const [message, setMessage] = useState(<span>&nbsp;</span>);
  const [entityName, setEntityName] = useState(team.entity_name);
  const [friendlyUrl, setFriendlyUrl] = useState(team.friendly_url);
  const [email, setEmail] = useState(team.email);
  const [statusCode, setStatusCode] = useState(team.status_code);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (statusCode === 2) {
      setIsSwitchOn(false);
    }
  }, [statusCode]);
  //handle form typing
  const handleEntityNameTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setEntityName(e.target.value);
  };
  const handleFriendlyUrlTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setFriendlyUrl(e.target.value);
  };
  const handleEmailTyping = (e) => {
    setMessage(<span>&nbsp;</span>);
    setEmail(e.target.value);
  };
  function closeModal() {
    props.handleClose();
    setSaving(false);
    setMessage(<span>&nbsp;</span>);
  }

  //toggle switch function and setting Team Status
  const onSwitchAction = () => {
    if (isSwitchOn) {
      setIsSwitchOn(false);
      setStatusCode(2);
    } else {
      setIsSwitchOn(true);
      setStatusCode(1);
    }
  };
  //UPDATE a team
  async function updateTeamData() {
    console.log('$$$$$ Updateing TEAM $$$$$$$');
    if (!entityName || !friendlyUrl || !email) {
      setMessage(
        <span style={{ color: 'red' }}>Please fill out each field</span>
      );
      setValidated(true);
      return;
    } else {
      //setup patch
      let teamEditPatch = {
        entity_name: entityName,
        friendly_url: friendlyUrl,
        email: email,
        status_code: statusCode
      };
      let teamAddObj = {
        account_level: 'standard',
        entity_name: entityName,
        friendly_url: friendlyUrl,
        email: email,
        status_code: statusCode
      };
      setSaving(true);
      setMessage(<span style={{ color: 'green' }}>Saving...</span>);
      if (team.entity_uuid) {
        //UPDATE THE TEAM
        await axios.patch(
          `${apiUrl}organizations/${team.entity_uuid}`,
          teamEditPatch
        );
      } else if (!team.entity_uuid) {
        //ADD A NEW TEAM
        await axios.post(`${apiUrl}organizations`, teamAddObj);
      }
      closeModal();
    }
  }

  const responsiveTheme =
    user_context.theme === 'light'
      ? { backgroundColor: 'white', color: 'black' }
      : { backgroundColor: 'rgb(25,25,25)', color: 'white' };

  return (
    // EDIT A TEAM
    team ? (
      <Modal show={props.show} onHide={closeModal}>
        <Modal.Header className="justify-content-around" style={responsiveTheme}>
          <h4>{team.entity_name ? 'Edit Team' : 'Add Team'}</h4>
          <Form>
            <Form.Switch
              style={{ transform: 'scale(1.5)' }}
              onChange={onSwitchAction}
              id="custom-switch"
              label=<span>
                <span
                  style={{
                    fontWeight: !isSwitchOn ? 'bold' : 'lighter',
                    //color: 'black'
                  }}>
                  Inactive
                </span>
                <span> or </span>
                <span
                  style={{
                    fontWeight: isSwitchOn ? 'bold' : 'lighter',
                    //color: 'black'
                  }}>
                  Active
                </span>
              </span>
              checked={isSwitchOn}
            />
          </Form>
        </Modal.Header>
        <Modal.Body style={responsiveTheme}>
          <Form validated={validated} onSubmit={(e) => e.preventDefault()}>
            <Form.Group controlId="teamName">
              <Form.Label>Team Name</Form.Label>
              <Form.Control
                type="text"
                onChange={handleEntityNameTyping}
                defaultValue={team.entity_name}
                required
                disabled={saving}
              />
            </Form.Group>

            <Form.Group controlId="friendlyUrl">
              <Form.Label>Friendly Url</Form.Label>
              <Form.Control
                type="text"
                onChange={handleFriendlyUrlTyping}
                defaultValue={team.friendly_url}
                required
                disabled={saving}
              />
            </Form.Group>

            <Form.Group controlId="jobLink">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="text"
                onChange={handleEmailTyping}
                defaultValue={team.email}
                required
                disabled={saving}
              />
            </Form.Group>
          </Form>
          {message}
        </Modal.Body>
        <Modal.Footer style={responsiveTheme}>
          <Button variant="secondary" onClick={() => closeModal()}>
            Close
          </Button>
          <Button variant="pkprimary" onClick={() => updateTeamData()}>
            Save Team
          </Button>
        </Modal.Footer>
      </Modal>
    ) : (
      <React.Fragment />
    )
  );
}

export default AddEditModal;
